// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fsqw","right":"styles_right__3ht-a"};